<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms">
  <div class="accordion-class">
    <h5>Cancel Trip</h5>
    <!-- <div class="row mt-4">
      <mat-radio-group> </mat-radio-group>
      <div class="col-md-2">
        <mat-radio-button
          (change)="selectLoadedQty('Fully-Refund')"
        ></mat-radio-button>
      </div>
      <div class="col-md-6">
        <div><b>Refund Full Amount</b></div>
      </div>
      <div class="col-md-4">
        <div class="amount text-right">₹ {{ actualAmountPaid }} /-</div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2">
        <mat-radio-button
          (change)="selectLoadedQty('Partial-Refund')"
        ></mat-radio-button>
      </div>
      <div class="col-md-6">
        <div><strong>Partial Refund (2%)</strong></div>
      </div>
      <div class="col-md-4">
        <div class="amount text-right">₹ {{ partialRefund }} /-</div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2">
        <mat-radio-button
          (change)="selectLoadedQty('Others-Refund')"
        ></mat-radio-button>
      </div>
      <div class="col-md-6">
        <div><b>Others</b></div>
      </div>
      <div class="col-md-4 d-flex others gap-2">
        <span class="mt-1">₹</span>
        <input appTwoDigitDecimaNumber matInput (input)="onInput($event)" />
      </div>
    </div> -->
    <!-- <div class="row mt-4">
      <div class="col-md-2"></div>
      <div class="col-md-6">
        <div>Payment Mode</div>
      </div>
      <div class="col-md-4 d-flex others">
        <input
          type="text"
          matInput
          [(ngModel)]="paymentMode"
          [ngModelOptions]="{ standalone: true }"
          />
        </div>
      </div> -->
      
      <ng-container *ngIf="!isCorporateUser">
        <div class="row mt-4">
          <mat-radio-group> </mat-radio-group>
          <div class="col-md-2">
            <mat-radio-button (change)="selectLoadedQty('Fully-Refund')"></mat-radio-button>
          </div>
          <div class="col-md-6">
            <div><b>Refund Full Amount</b></div>
          </div>
          <div class="col-md-4">
            <div class="amount text-right">₹ {{ actualAmountPaid }} /-</div>
          </div>
        </div>
  
        <div class="row mt-4">
          <div class="col-md-2">
            <mat-radio-button (change)="selectLoadedQty('Partial-Refund')"></mat-radio-button>
          </div>
          <div class="col-md-6">
            <div><strong>Partial Refund (2%)</strong></div>
          </div>
          <div class="col-md-4">
            <div class="amount text-right">₹ {{ partialRefund }} /-</div>
          </div>
        </div>
  
        <div class="row mt-4">
          <div class="col-md-2">
            <mat-radio-button (change)="selectLoadedQty('Others-Refund')"></mat-radio-button>
          </div>
          <div class="col-md-6">
            <div><b>Others</b></div>
          </div>
          <div class="col-md-4 d-flex others gap-2">
            <span class="mt-1">₹</span>
            <input appTwoDigitDecimaNumber matInput (input)="onInput($event)" />
          </div>
        </div>
      </ng-container>
    <div class="row mt-4">
      <div class="col-md-2"></div>
      <div class="col-md-6">
        <div><b>Date</b></div>
      </div>
      <div class="col-md-4 d-flex others">
        <input type="text" matInput readonly [value]="value" />
      </div>
    </div>
    <div class="row mt-4">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label for="reason">Reason for cancelation</mat-label>
        <textarea
          matInput
          name="reason"
          id="reason"
          [(ngModel)]="reason"
          [ngModelOptions]="{ standalone: true }"
        ></textarea>
      </mat-form-field>
    </div>
    <button
      type="button"
      class="button buttonCancel mt-3"
      (click)="cancelTrip()"
    >
      Proceed to Cancel
    </button>
  </div>
</form>
